import { isSameSearchCriteria } from "domains/publication/reducer";
import { getTmSelectedOuterNode } from "domains/transformationMap/selectors";
import type { RootState } from "types/redux";

export const createVideosForTopicSelector = (id: string) => (state: RootState) =>
  state.domains.videos.forTopic[id]?.find((item) =>
    isSameSearchCriteria(item.searchCriteria, {
      ...getVideoSearchCriteria(state),
      id,
      secondaryTopicId: state.domains.transformationMap.selectedOuterNodeId,
    }),
  );

export const getVideoSearchCriteria = (state: RootState) => state.domains.videos.searchCriteria;

export const getVideoSearchTerm = (state: RootState) => getVideoSearchCriteria(state).search;

export const getIsVideosFiltered = (state: RootState) => {
  const { publication_type, search } = getVideoSearchCriteria(state);
  return !!publication_type || !!search || !!getTmSelectedOuterNode(state)?.id;
};

export const getVideosFilterCount = (state: RootState) => {
  const { publication_type, search } = getVideoSearchCriteria(state);
  let count = 0;
  if (publication_type) count++;
  if (search) count++;
  return count;
};
